import { LegalHold } from '../../../../domain/src/lib/legal-hold/legal-hold.model';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** Parte calendario (YYYY-MM-DD) de un date-time ISO del servidor. */
export function toLegalHoldDatePart(value: string | undefined | null): string {
  const v = (value ?? '').trim();
  if (!v) return '';
  const datePart = v.slice(0, 10);
  return ISO_DATE.test(datePart) ? datePart : '';
}

/** ISO del servidor → Date local para el datepicker (sin hora). */
export function parseLegalHoldDateForPicker(value: string | Date | null | undefined): Date | null {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const datePart = toLegalHoldDatePart(value);
  if (!datePart) return null;
  const [y, m, d] = datePart.split('-').map(Number);
  const parsed = new Date(y, m - 1, d);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** Fecha corta para tabla y consulta (sin hora del servidor). */
export function formatLegalHoldDateDisplay(value: string | undefined | null): string {
  const parsed = parseLegalHoldDateForPicker(value);
  if (!parsed) {
    const datePart = toLegalHoldDatePart(value);
    return datePart || '-';
  }
  return parsed.toLocaleDateString('es-CO');
}

/** Datepicker → ISO date-time con solo la fecha (medianoche UTC). */
export function toLegalHoldDateApi(value: Date | string | null | undefined): string | undefined {
  const parsed = parseLegalHoldDateForPicker(value);
  if (!parsed) return undefined;
  const y = parsed.getFullYear();
  const m = String(parsed.getMonth() + 1).padStart(2, '0');
  const d = String(parsed.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}T00:00:00.000Z`;
}

/** Fecha de inicio al crear un caso (solo día, sin hora del servidor). */
export function toLegalHoldStartDateApi(): string {
  return toLegalHoldDateApi(new Date())!;
}

export function matchesLegalHoldSearch(row: LegalHold, term: string): boolean {
  const normalized = (term || '').trim().toLowerCase();
  if (!normalized) return true;
  return [row.case_name, row.case_number || '', row.description || '']
    .join(' ')
    .toLowerCase()
    .includes(normalized);
}

export function toLegalHoldStatusLabel(status: 'active' | 'closed'): string {
  return status === 'active' ? 'Activo' : 'Cerrado';
}
